// extracted by mini-css-extract-plugin
export default {"productGallery":"CG-z","inQuickShop":"DG-z"};